import {
    FETCH_POLICIES_REQUEST,
    FETCH_POLICIES_SUCCESS,
    FETCH_POLICIES_FAILURE,
    FETCH_ACTIVITY_POLICY_BY_ID_REQUEST,
    FETCH_ACTIVITY_POLICY_BY_ID_SUCCESS,
    FETCH_ACTIVITY_POLICY_BY_ID_FAILURE,
    CHANGE_ACTIVITY_POLICY_STATUS_REQUEST,
    CHANGE_ACTIVITY_POLICY_STATUS_SUCCESS,
    CHANGE_ACTIVITY_POLICY_STATUS_FAILURE,
    DELETE_ACTIVITY_POLICY_REQUEST,
    DELETE_ACTIVITY_POLICY_SUCCESS,
    DELETE_ACTIVITY_POLICY_FAILURE,
} from '../actions/policiesActions';

const initialState = {
    list: { data: null, loading: false, error: null },
    selectedPolicy: { data: null, loading: false, error: null },
    changePolicyStatus: { loading: false, error: null, success: false },
    deletePolicy: { loading: false, error: null, success: false },
};

const policiesReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_POLICIES_REQUEST:
            return { ...state, list: { data: state.list.data, loading: true, error: null } };
        case FETCH_POLICIES_SUCCESS:
            return { ...state, list: { data: action.payload, loading: false, error: null } };
        case FETCH_POLICIES_FAILURE:
            return { ...state, list: { data: null, loading: false, error: action.payload } };

        case FETCH_ACTIVITY_POLICY_BY_ID_REQUEST:
            return {
                ...state,
                selectedPolicy: {
                    loading: true,
                    error: null,
                    data: null,
                },
            };

        case FETCH_ACTIVITY_POLICY_BY_ID_SUCCESS:
            return {
                ...state,
                selectedPolicy: {
                    loading: false,
                    error: null,
                    data: action.payload,
                },
            };

        case FETCH_ACTIVITY_POLICY_BY_ID_FAILURE:
            return {
                ...state,
                selectedPolicy: {
                    loading: false,
                    error: action.payload,
                    data: null,
                },
            };

        case CHANGE_ACTIVITY_POLICY_STATUS_REQUEST:
            return {
                ...state,
                changePolicyStatus: {
                    loading: true,
                    error: null,
                    success: false,
                },
            };

        case CHANGE_ACTIVITY_POLICY_STATUS_SUCCESS:
            return {
                ...state,
                changePolicyStatus: {
                    loading: false,
                    error: null,
                    success: true,
                },
                // Mettre à jour le statut dans selectedPolicy si la police est actuellement chargée
                selectedPolicy: state.selectedPolicy.data ? {
                    ...state.selectedPolicy,
                    data: {
                        ...state.selectedPolicy.data,
                        policy_info: {
                            ...state.selectedPolicy.data.policy_info,
                            status: action.payload.status || state.selectedPolicy.data.policy_info?.status,
                        },
                    },
                } : state.selectedPolicy,
            };

        case CHANGE_ACTIVITY_POLICY_STATUS_FAILURE:
            return {
                ...state,
                changePolicyStatus: {
                    loading: false,
                    error: action.payload,
                    success: false,
                },
            };

        case DELETE_ACTIVITY_POLICY_REQUEST:
            return {
                ...state,
                deletePolicy: {
                    loading: true,
                    error: null,
                    success: false,
                },
            };

        case DELETE_ACTIVITY_POLICY_SUCCESS:
            // Le payload contient le policyId qui a été supprimé
            const deletedPolicyId = action.payload;
            return {
                ...state,
                deletePolicy: {
                    loading: false,
                    error: null,
                    success: true,
                },
                // Retirer la police supprimée de la liste si elle est présente
                list: state.list.data && state.list.data.data ? {
                    ...state.list,
                    data: {
                        ...state.list.data,
                        data: state.list.data.data.filter(
                            item => {
                                const policyId = item?.policy_info?.policy_id || item?.policy_id || item?.policy_info?.id;
                                return policyId !== deletedPolicyId;
                            }
                        ),
                    },
                } : state.list,
            };

        case DELETE_ACTIVITY_POLICY_FAILURE:
            return {
                ...state,
                deletePolicy: {
                    loading: false,
                    error: action.payload,
                    success: false,
                },
            };

        default:
            return state;
    }
};

export default policiesReducer;



